/* モフトレ通信 */
import * as React from 'react';
import KanaList from '../containers/KanaList';
import { userListHeader, UserSelectBody, Type } from './UserListField';

import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import * as PropTypes from 'prop-types';
import * as Header from '../constants/Header';

interface UserSelectPressProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;
}

class UserSelectPress extends React.Component<UserSelectPressProps, {}> {
  static propTypes = {
    moffAPI: PropTypes.any.isRequired,
    moffAPIActions: PropTypes.any.isRequired,
  };

  componentWillMount() {
    document.title = 'モフトレ通信';

    this.props.headerActions.setPage(Header.USER_SELECT_PRESS);

    // Action
    this.props.moffAPIActions.getUsers();
  }

  render () {
    return (
      <div>
        <KanaList />
        { // 
          (() => {
            if (this.props.moffAPI.Loaded) {
              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }

        <div id="userlist">
          <table className="tblStyle01">
            <thead>
              <tr>
                {userListHeader}
              </tr>
            </thead>
            <tbody>
            {(this.props.moffAPI.Loaded) ? 
              // ロードしたUserを表示.
              <UserSelectBody
                type={Type.MoffPress}
                users={this.props.moffAPI.result}
              /> 
             :
              // ロード中.
              (null)
            }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default UserSelectPress;



// WEBPACK FOOTER //
// ./src/components/UserSelectPress.tsx